<template>
  <div>
    <CCard style="margin-top: 10px">
      
      <CCardBody>
          <h3 style="float: left">Token Balance</h3>
        <CDataTable
          :items="token"
          :fields="fields"
          pagination
          clickable-rows
          hover
        >
          <template #image="{ item }">
            <td>
              <img
                :src="item.image"
                style="width: 50px; border-radius: 50px; height: 50px"
              />
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
const db = firebase.firestore();
export default {
  data() {
    return {
      token: [],
      options: [],
      grapdata: null,
      balancedata: "",
      balanceshow: false,
      fields: [
        {
          label: "Image",
          key: "image",
          sortable: true,
        },
        {
          label: "Name",
          key: "name",
          sortable: true,
        },
        {
          label: "Balance",
          key: "balance",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    tokenbalance() {
      const db = firebase.firestore();
      let address = "0x1D796185629d0FE6E99A23EED19F5dFb414D918b"
      db.collection("companyDetails2")
        // .where("name", "==", this.grapdata)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            if (doc.data().isBalance == true) {
              if (doc.data().name == "Matic") {
                console.log("doc.data().ethAddress",doc.data().ethAddress)
                axios
                  .get(
// "https://api.polygonscan.com/api?module=account&action=balance&address=0x1D796185629d0FE6E99A23EED19F5dFb414D918b&tag=latest&apikey=37P5JKA8MP6PFCJM79NZFRHN37MIQACJNM"

                    "https://api.polygonscan.com/api?module=account&action=balance&address="+doc.data().ethAddress+"&tag=latest&apikey=37P5JKA8MP6PFCJM79NZFRHN37MIQACJNM"
                   
                  )
                  .then((res) => {
                    console.log("Matic", res.data.result);
                    // this.balancedata = res.data.ETH.balance.toFixed(5);
                    // this.balanceshow = true;
                    this.token.push({
                      name: doc.data().name,
                      image: doc.data().logo,
                      balance: (res.data.result/ 1e18).toFixed(2),
                    });
                  });
              } else {
                axios
                  .get(
                    "https://api.polygonscan.com/api?module=account&action=tokenbalance&contractaddress=" +
                      doc.data().conAddress +
                      "&address=" +
                      doc.data().ethAddress +
                      "&tag=latest&apikey=37P5JKA8MP6PFCJM79NZFRHN37MIQACJNM"
                  )
                  .then((res) => {
                    //    console.log("name",doc.data().name);
                    // console.log("res", res);
                    this.token.push({
                      name: doc.data().name,
                      image: doc.data().logo,
                      balance: res.data.result / 1e18,
                    });
                    // console.log("this.token", this.token);
                    // this.balancedata = res.data.result / 1e18;
                    //  this.balanceshow = true;
                  });
              }
            }
          });
        });
    },
  },
  created() {
    this.tokenbalance();
  },
};
</script>